import Layout from "../components/layout/Layout";
import MansionGenChat from "../components/MansionGenChat";
import PublicText from "../components/PublicText";
import { PUBLIC_BRAND } from "../lib/public-copy";

export default function CommunityPage() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 py-12">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-700 mb-2">
          Caribbean Community
        </p>
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Island Chat</h1>
        <PublicText as="p" className="text-slate-600 text-sm mb-8 max-w-xl leading-relaxed">
          {PUBLIC_BRAND.unifiedNetworkLead}
        </PublicText>
        <MansionGenChat title="CheepSweepz Chat" theme="light" className="max-w-2xl" />
      </div>
    </Layout>
  );
}
